import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Formatters } from "../../../Utils/Formatters";
import { withNamespaces } from "react-i18next";
import Avatar from "@material-ui/core/Avatar";
import PersonIcon from "@material-ui/icons/Person";
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import TrafficIcon from "@material-ui/icons/Traffic";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import { Card } from "@material-ui/core";

const UserData = ({ t, user, next_booking }) => {
  console.log(user);
  return (
    <Card>
      <List>
        <ListItem>
          <Avatar>
            <PersonIcon />
          </Avatar>
          <ListItemText
            primary={t("Name")}
            secondary={`${user.first_name} ${user.last_name}`}
          />
        </ListItem>

        {user.last_visit_at && (
          <ListItem>
            <Avatar>
              <TransferWithinAStationIcon />
            </Avatar>
            <ListItemText
              primary={t("Last visit")}
              secondary={Formatters.formatDate(user.last_visit_at.date)}
            />
          </ListItem>
        )}

        <ListItem>
          <Avatar>
            <AttachMoneyIcon />
          </Avatar>
          <ListItemText
            primary={t("Your Balance")}
            secondary={Formatters.formatMoney(user.t_amount)}
          />
        </ListItem>

        {user.remainingFichas !== undefined && user.remainingFichas !== null && (
          <ListItem>
            <Avatar>
              <TrafficIcon />
            </Avatar>
            <ListItemText
              primary={t("Remaining Fichas")}
              secondary={user.remainingFichas}
            />
          </ListItem>
        )}

        {next_booking && (
          <ListItem>
            <Avatar>
              <FitnessCenterIcon />
            </Avatar>
            <ListItemText
              primary={t("Next Booking")}
              secondary={`${next_booking.name}. ${Formatters.formatDate(
                next_booking.date,
                "DD-MM"
              )} a las ${Formatters.formatTime(next_booking.start_at)}`}
            />
          </ListItem>
        )}
      </List>
    </Card>
  );
};

export default withNamespaces()(UserData);
